import { render, staticRenderFns } from "./DoctorFormEdit.vue?vue&type=template&id=5da29dbc&scoped=true&"
import script from "./DoctorFormEdit.vue?vue&type=script&lang=js&"
export * from "./DoctorFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./DoctorFormEdit.vue?vue&type=style&index=0&id=5da29dbc&scoped=true&lang=css&"
import style1 from "./DoctorFormEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da29dbc",
  null
  
)

export default component.exports